// Native <audio> player for stimulus audio (`audio_ref` on a set's stimulus).
// Fetches the bytes via `contentAudioBlob` (same auth-gated path the runners
// use) and hands the resulting object URL to a controlled <audio controls>.
// This is the review-page counterpart to <SignedAudioPlayer> (which serves
// student recordings): SignedAudioPlayer plays what the student SAID,
// ContentAudioPlayer plays what the student HEARD.
import React, { useEffect, useState } from 'react';
import { Headphones } from 'lucide-react';

import { api } from '@/lib/api';
import { cn } from '@/lib/utils';

export default function ContentAudioPlayer({ audioRef, className, testId }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setUrl(null);
    setFailed(false);
    if (!audioRef) return undefined;
    let alive = true;
    let obj = null;
    api.contentAudioBlob(audioRef)
      .then((res) => { if (!alive) return; obj = URL.createObjectURL(res.data); setUrl(obj); })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; if (obj) URL.revokeObjectURL(obj); };
  }, [audioRef]);

  if (failed) {
    return (
      <p className={cn('text-xs text-slate-500', className)} data-testid={testId ? `${testId}-error` : undefined}>
        Couldn’t load the prompt audio.
      </p>
    );
  }
  if (!url) {
    return (
      <p className={cn('flex items-center gap-2 text-xs text-slate-400', className)}>
        <Headphones className="h-3.5 w-3.5" /> Loading prompt audio…
      </p>
    );
  }
  return (
    <audio controls src={url} className={cn('w-full', className)} data-testid={testId} />
  );
}
